import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ContractPaymentsListQuery } from "../graphql/queries";
import type {
  ContractPaymentsListQueryType,
  ContractPaymentsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useContractPaymentsQuery = (
  options?: QueryHookOptions<
    ContractPaymentsListQueryType,
    ContractPaymentsListQueryVariablesType
  >
) => {
  return useQuery<
    ContractPaymentsListQueryType,
    ContractPaymentsListQueryVariablesType
  >(ContractPaymentsListQuery, options);
};
